/*
 * Custom theme JS — Lavindrey
 *
 * Cleaned 2026-05: removed geolocation popup (popup-overlay + external redirect). Preserved:
 *   - getCookie / setCookie helpers (kept in case other scripts read them)
 *   - Countdown timer (#timer with data-endtime)
 *   - Collapsible accordion (.collapsiable_item / .collapsiable_action_btn)
 *   - Sticky add-to-cart variant sync (variant:change → product-sticky-bar)
 *   - Tiny Slider init for [data-slider] elements
 *   - Mega-menu hover overlay logic
 */

jQuery(document).ready(function ($) {
  // -------- Cookie helpers (kept for any external dependency) --------
  function getCookie(cname) {
    for (var name = cname + "=", ca = document.cookie.split(";"), i = 0; i < ca.length; i++) {
      for (var c = ca[i]; c.charAt(0) == " ";) c = c.substring(1);
      if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
  }
  window.getCookie = getCookie;

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  window.setCookie = setCookie;

  // -------- Countdown timer --------
  function myTimer() {
    var ending = jQuery("#timer").attr("data-endtime");
    if (!ending) return;
    var endTime = new Date(ending);
    endTime = Date.parse(endTime) / 1000;
    var now = new Date();
    now = Date.parse(now) / 1000;
    var timeLeft = endTime - now;
    var days = Math.floor(timeLeft / 86400);
    var hours = Math.floor((timeLeft - days * 86400) / 3600);
    var minutes = Math.floor((timeLeft - days * 86400 - hours * 3600) / 60);
    var seconds = Math.floor(timeLeft - days * 86400 - hours * 3600 - minutes * 60);
    if (days < 10) days = "0" + days;
    if (days < 1) days = "0";
    if (hours < 10) hours = "0" + hours;
    if (hours < 1) hours = "0";
    if (minutes < 10) minutes = "0" + minutes;
    if (minutes < 1) minutes = "0";
    if (seconds < 10) seconds = "0" + seconds;
    if (seconds < 1) seconds = "0";
    $("#timer").html(
      "<span id='hours'>" + hours + "<span>Hrs</span></span>" +
      "<span class='clone'>:</span>" +
      "<span id='minutes'>" + minutes + "<span>Mins</span></span>" +
      "<span class='clone'>:</span>" +
      "<span id='seconds'>" + seconds + "<span>Secs</span></span>"
    );
  }
  setInterval(function () { myTimer(); }, 1000);

  // -------- Collapsible accordion (legacy) --------
  $(".collapsiable_item:nth-child(1) .collapsiable_action_btn").addClass("active");
  $(".collapsiable_item:nth-child(1) .collapsiable_content").slideDown();
  $(".collapsiable_action_btn").on("click", function () {
    $(this).siblings(".collapsiable_content").slideToggle();
    $(this).toggleClass("active");
  });
});

// -------- Sticky add-to-cart: keep variant in sync --------
document.addEventListener("DOMContentLoaded", () => {
  document.addEventListener("variant:change", function (e) {
    var variant = e.detail.variant.id;
    var stickyBar = document.querySelector("product-sticky-bar");
    if (stickyBar) {
      stickyBar.querySelector('[name="id"]').value = variant;
    }
  });
});

// -------- Tiny Slider init for any [data-slider] --------
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-slider]").forEach(slider => {
    const options = JSON.parse(slider.getAttribute("data-slider"));
    if (options.controls) {
      const sliderOptions = {
        container: slider.querySelector(".slider-items"),
        controlsContainer: slider.nextElementSibling,
        ...options
      };
      tns(sliderOptions);
    } else {
      const sliderOptions = {
        container: slider.querySelector(".slider-items"),
        ...options
      };
      tns(sliderOptions);
    }
  });
});

// -------- Mega-menu hover overlay --------
document.addEventListener("DOMContentLoaded", function () {
  const menuOverlay = document.querySelector(".menu-overlay");
  if (!menuOverlay) return;
  let isOverMegaMenu = false;

  document.querySelectorAll(".header__primary-nav-item details").forEach(function (menuItem) {
    menuItem.addEventListener("mouseenter", function () {
      if (menuItem.querySelector(".mega-menu") && !document.querySelector("#header-search[open]")) {
        isOverMegaMenu = true;
        menuOverlay.classList.add("visible");
      } else {
        isOverMegaMenu = false;
        setTimeout(() => {
          if (!isOverMegaMenu) menuOverlay.classList.remove("visible");
        }, 250);
      }
    });
    menuItem.addEventListener("mouseleave", function () {
      if (menuItem.querySelector(".mega-menu")) {
        isOverMegaMenu = false;
        setTimeout(() => {
          if (!isOverMegaMenu) menuOverlay.classList.remove("visible");
        }, 250);
      }
    });
  });

  menuOverlay.addEventListener("mouseenter", function () {
    isOverMegaMenu = false;
    setTimeout(() => {
      if (!isOverMegaMenu) menuOverlay.classList.remove("visible");
    }, 250);
  });
  menuOverlay.addEventListener("mouseleave", function () {
    isOverMegaMenu = false;
    setTimeout(() => {
      if (!isOverMegaMenu) menuOverlay.classList.remove("visible");
    }, 250);
  });
});
